export const oidc = (state) => state.oidc;
export const access_token = (state) =>state.oidc.user.access_token;
